export const MODULE_FILE = '/module_file/'
export const MODULE_FILE_ACTIVATE = `${MODULE_FILE}activate/`
export const MODULE_FILE_ALL = `${MODULE_FILE}all`
